import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Wraps children in a container that triggers a CSS fade-in
 * animation each time the route pathname changes.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-transition">
      {children}
    </div>
  );
};

export default PageTransition;
